<template>
  <div class="mt-4" v-if="project.consortium !== null">
    <v-row>
      <v-col cols="12">
        <v-checkbox
          v-model="project.consortium.is_citius"
          :label="$t('form.project.consortium_citius')"
          :value="project.consortium.is_citius"
          :readonly="true"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          :value="project.consortium.start_date"
          :label="$t('form.project.consortium_startDate')"
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="project.consortium.end_date"
          :label="$t('form.project.consortium_endDate')"
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="project.consortium.leader.name"
          :label="$t('form.project.leader')"
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          :value="project.consortium.partners.map(p => p.name)"
          :label="$t('form.project.partners')"
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
  <div class="mt-8" v-else>
    <v-row class="justify-center">
      <v-col cols="12" md="6">
        <v-alert dense text type="info">
          {{ $t("project.no.consortium") }}
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import project_data from "../../mixins/project_data";

export default {
  name: "DetailConsortium",
  props: {
    project_id: Number
  },

  data() {
    return {};
  },
  mixins: [project_data],
  created() {
    this.getProject(
      this.$store.state.endpoint + "/user/project/" + this.project_id
    );
  }
};
</script>

<style scoped></style>
